// eslint-disable-next-line import/no-unresolved
export * from 'element-tiptap/src/constants';
